import React, { createContext, useContext } from 'react';

import TenantConfig from '../config';
import { UserContext } from '../context/UserContext';

const RudderContext = createContext({});

export const RudderProvider = ({ rudder, children }) => (
  <RudderContext.Provider value={rudder}>{children}</RudderContext.Provider>
);

export const useRudder = () => {
  const rudder = useContext(RudderContext);
  const { profile } = useContext(UserContext);

  const identify = () => {
    let tenant = TenantConfig.getTenant();
    if (profile && rudder && rudder.identify) {
      rudder.identify(profile?.email, { ...profile, tenant });
    }
  };

  const leavePage = () => {
    if (rudder && rudder.page) {
      rudder.page('Borrower application flow', 'Leave');
    }
  };

  const errorEvent = (name = 'Error', payload) => {
    if (rudder && rudder.track) {
      rudder.track(name, {
        ...payload,
      });
    }
  };

  const pageEvent = () => {
    if (rudder && rudder.page) {
      rudder.page('Borrower application flow', 'Page change');
    }
  };

  const clickEvent = (event) => {
    const clickTargets = ['INPUT', 'BUTTON', 'SPAN'];
    if (clickTargets.includes(event.target.tagName)) {
      const { target } = event;
      const targetData = {};
      targetData['element'] = target.outerHTML;
      if (rudder && rudder.track) {
        rudder.track('Click', targetData);
      }
    }
  };

  return {
    rudder,
    identify,
    leavePage,
    errorEvent,
    pageEvent,
    clickEvent,
  };
};

export const load = (rudder) => {
  rudder.load(process.env.REACT_APP_RUDDER_WRITE_KEY, process.env.REACT_APP_RUDDER_DATA_URL, {
    configUrl: process.env.REACT_APP_RUDDER_DATA_URL,
    context: { tenantId: process.env.REACT_APP_TENANT_NAME },
  });
};
